import React from 'react'
import styled from 'styled-components'

type StartLuckyDrawProps = {
  onStart: () => void
}

export default function StartLuckyDraw({ onStart }: StartLuckyDrawProps) {
  return (
    <Wrapper>
      <button onClick={onStart} className="theme-btn">
        Start Draw
      </button>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 29%;

  button {
    appearance: none;
    user-select: none;
    border: none;
    font-size: 3rem;
    font-weight: 700;
    text-transform: uppercase;
    border: 2px solid var(--Game_Stroke, #70ecf4);

    &:hover {
      color: #fff;
    }
  }
`
